import { render, staticRenderFns } from "./SleepRecord.vue?vue&type=template&id=f2613400"
import script from "./SleepRecord.vue?vue&type=script&lang=js"
export * from "./SleepRecord.vue?vue&type=script&lang=js"
import style0 from "./SleepRecord.vue?vue&type=style&index=0&id=f2613400&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2613400')) {
      api.createRecord('f2613400', component.options)
    } else {
      api.reload('f2613400', component.options)
    }
    module.hot.accept("./SleepRecord.vue?vue&type=template&id=f2613400", function () {
      api.rerender('f2613400', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/health/SleepRecord.vue"
export default component.exports